let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5cajC")).then(() => parcelRequire('i3wkz'));